"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Audit() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="501" id="auditcta" className="bg-background text-foreground relative w-full overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[60vh] lg:min-h-[80vh]">
        {}
        <div ref={leftRef} className={`group relative flex-1 overflow-hidden min-h-[60vh] lg:min-h-[80vh] transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/revenue_audit_analysis.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/revenue_audit_analysis.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/revenue_audit_analysis.png-wvc-sizes" alt="Professional revenue audit and data analysis on a tablet" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]" />

          {}
          <div className="absolute inset-0" style={{
          background: "linear-gradient(135deg, hsla(222, 47%, 7%, 0.85) 0%, hsla(222, 47%, 14%, 0.75) 50%, hsla(222, 47%, 22%, 0.6) 100%)",
          opacity: 0.8
        }} />
          <div className="absolute inset-0 bg-background/20" />

          {}
          <div aria-hidden="true" className="hidden lg:block absolute top-0 right-0 h-full w-px overflow-hidden">
            <div className="absolute inset-y-0 right-0 w-px bg-foreground/20" />
            <div className="absolute right-0 h-24 w-px bg-[hsl(43,46%,55%)] opacity-0 group-hover:opacity-80 group-hover:animate-[tide_2.5s_ease-in-out_infinite] transition-opacity duration-500" />
          </div>

          {}
          <div className="relative z-10 flex h-full items-center justify-center p-8 sm:p-12 lg:p-16">
            <div className="max-w-xl">
              <p className="font-default text-xs sm:text-sm tracking-[0.3em] uppercase mb-6" style={{
              color: "hsl(43, 46%, 55%)"
            }}>
                Consulting
              </p>
              <h2 className="font-default font-light leading-[1.05] tracking-tight text-white mb-6" style={{
              fontSize: "clamp(2.5rem, 5vw, 5rem)"
            }}>
                Revenue Audit
              </h2>
              <p className="text-base sm:text-lg text-white/90 leading-relaxed mb-10 max-w-md">
                Identify hidden revenue leaks and optimize your property's performance with a comprehensive, data-driven audit from our experts.
              </p>
              <Button asChild size="lg" className="rounded-lg px-8 py-6 h-auto text-base font-medium transition-transform duration-300 hover:scale-105 shadow-lg" style={{
              backgroundColor: "hsl(43, 46%, 55%)",
              color: "hsl(222, 47%, 7%)"
            }}>
                <Link to="/RevenueManagementConsultingPage">
                  Request Audit
                  <ArrowRight className="ml-1 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`group relative flex-1 overflow-hidden min-h-[60vh] lg:min-h-[80vh] transition-all duration-1000 ease-out delay-150 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
        backgroundColor: "hsl(215, 16%, 92%)"
      }}>
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_tech_implementation.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_tech_implementation.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_tech_implementation.png-wvc-sizes" alt="Modern hotel technology dashboard and software integration" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]" />

          {}
          <div className="absolute inset-0" style={{
          background: "linear-gradient(135deg, hsla(222, 47%, 98%, 0.85) 0%, hsla(222, 47%, 90%, 0.7) 100%)"
        }} />

          {}
          <div aria-hidden="true" className="hidden lg:block absolute top-0 left-0 h-full w-px overflow-hidden">
            <div className="absolute inset-y-0 left-0 w-px" style={{
            backgroundColor: "hsl(222, 47%, 7%, 0.2)"
          }} />
            <div className="absolute left-0 h-24 w-px opacity-0 group-hover:opacity-80 group-hover:animate-[tide_2.5s_ease-in-out_infinite] transition-opacity duration-500" style={{
            backgroundColor: "hsl(43, 46%, 55%)"
          }} />
          </div>

          {}
          <div className="relative z-10 flex h-full items-center justify-center p-8 sm:p-12 lg:p-16">
            <div className="max-w-xl">
              <p className="font-default text-xs sm:text-sm tracking-[0.3em] uppercase mb-6" style={{
              color: "hsl(222, 47%, 7%)"
            }}>
                Strategy
              </p>
              <h2 className="font-default font-light leading-[1.05] tracking-tight mb-6" style={{
              fontSize: "clamp(2.5rem, 5vw, 5rem)",
              color: "hsl(222, 47%, 7%)"
            }}>
                Tech Solutions
              </h2>
              <p className="text-base sm:text-lg leading-relaxed mb-10 max-w-md" style={{
              color: "hsl(222, 47%, 20%)"
            }}>
                Streamline your operations with the right hospitality tech stack. We recommend and implement tools that drive efficiency and direct bookings.
              </p>
              <Button asChild size="lg" className="rounded-lg px-8 py-6 h-auto text-base font-medium transition-transform duration-300 hover:scale-105 shadow-lg" style={{
              backgroundColor: "hsl(222, 47%, 7%)",
              color: "hsl(0, 0%, 98%)"
            }}>
                <Link to="#">
                  Explore Services
                  <ArrowRight className="ml-1 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes tide {
          0% { transform: translateY(-100%); }
          50% { transform: translateY(0%); }
          100% { transform: translateY(100%); }
        }
      `}</style>
    </section>;
}